import api from '../../../../services/api';

// Product Categories Actions
export const FETCH_PRODUCT_CATEGORIES_START = 'FETCH_PRODUCT_CATEGORIES_START';
export const FETCH_PRODUCT_CATEGORIES_SUCCESS = 'FETCH_PRODUCT_CATEGORIES_SUCCESS';
export const FETCH_PRODUCT_CATEGORIES_ERROR = 'FETCH_PRODUCT_CATEGORIES_ERROR';

export const CREATE_PRODUCT_CATEGORY_START = 'CREATE_PRODUCT_CATEGORY_START';
export const CREATE_PRODUCT_CATEGORY_SUCCESS = 'CREATE_PRODUCT_CATEGORY_SUCCESS';
export const CREATE_PRODUCT_CATEGORY_ERROR = 'CREATE_PRODUCT_CATEGORY_ERROR';

export const UPDATE_PRODUCT_CATEGORY_START = 'UPDATE_PRODUCT_CATEGORY_START';
export const UPDATE_PRODUCT_CATEGORY_SUCCESS = 'UPDATE_PRODUCT_CATEGORY_SUCCESS';
export const UPDATE_PRODUCT_CATEGORY_ERROR = 'UPDATE_PRODUCT_CATEGORY_ERROR';

export const DELETE_PRODUCT_CATEGORY_START = 'DELETE_PRODUCT_CATEGORY_START';
export const DELETE_PRODUCT_CATEGORY_SUCCESS = 'DELETE_PRODUCT_CATEGORY_SUCCESS';
export const DELETE_PRODUCT_CATEGORY_ERROR = 'DELETE_PRODUCT_CATEGORY_ERROR';

// New filter actions
export const SET_CATEGORIES_FILTERS = 'SET_CATEGORIES_FILTERS';
export const CLEAR_CATEGORIES_FILTERS = 'CLEAR_CATEGORIES_FILTERS';

// Fetch all product categories with optional filters
export const fetchProductCategories = (filters = {}) => async (dispatch) => {
    console.log('fetchProductCategories called with filters:', filters);
    dispatch({ type: FETCH_PRODUCT_CATEGORIES_START });
    try {
        // Build query parameters for backend filtering
        const params = new URLSearchParams();
        
        // Add pagination params
        if (filters.page) params.append('page', filters.page);
        if (filters.pageSize) params.append('pageSize', filters.pageSize);
        
        // Add filter params
        if (filters.searchText) {
            params.append('search', filters.searchText);
        }
        if (filters.statusFilter && filters.statusFilter !== 'all') {
            const isActive = filters.statusFilter === 'active';
            params.append('isActive', isActive);
        }
        if (filters.codeFilter && filters.codeFilter !== 'all') {
            params.append('code', filters.codeFilter);
        }
        if (filters.productLineFilter && filters.productLineFilter !== 'all') {
            params.append('productLineId', filters.productLineFilter);
        }
        if (filters.sortBy) {
            params.append('sortBy', filters.sortBy);
        }
        if (filters.sortOrder) {
            params.append('sortOrder', filters.sortOrder);
        }
        
        const response = await api.get(`/categories?${params.toString()}`);
        console.log('API Response:', response.data); // Debug log
        
        // Handle the API response structure: { rows: [...], count: ..., pagination: ... }
        const categories = response.data?.rows || [];
        const pagination = response.data?.pagination || {};
        
        dispatch({ 
            type: FETCH_PRODUCT_CATEGORIES_SUCCESS, 
            payload: {
                categories,
                pagination,
                total: response.data?.count || 0
            }
        });
        return { success: true, data: categories };
    } catch (error) {
        console.error('Error fetching product categories:', error);
        dispatch({ 
            type: FETCH_PRODUCT_CATEGORIES_ERROR, 
            payload: 'Không thể tải danh sách danh mục sản phẩm' 
        });
        return { success: false, error: error.message };
    }
};

// Create a new product category
export const createProductCategory = (categoryData) => async (dispatch) => {
    dispatch({ type: CREATE_PRODUCT_CATEGORY_START });
    try {
        const response = await api.post('/categories', categoryData);
        const newCategory = response.data?.data || response.data;
        dispatch({ 
            type: CREATE_PRODUCT_CATEGORY_SUCCESS, 
            payload: newCategory 
        });
        return { success: true, data: newCategory };
    } catch (error) {
        console.error('Error creating product category:', error);
        dispatch({ 
            type: CREATE_PRODUCT_CATEGORY_ERROR, 
            payload: 'Không thể tạo danh mục sản phẩm mới' 
        });
        return { success: false, error: error.message };
    }
};

// Update a product category
export const updateProductCategory = (id, categoryData) => async (dispatch) => {
    dispatch({ type: UPDATE_PRODUCT_CATEGORY_START });
    try {
        const response = await api.put(`/categories/${id}`, categoryData);
        const updatedCategory = response.data?.data || response.data;
        dispatch({ 
            type: UPDATE_PRODUCT_CATEGORY_SUCCESS, 
            payload: { id, ...updatedCategory } 
        });
        return { success: true, data: updatedCategory };
    } catch (error) {
        console.error('Error updating product category:', error);
        dispatch({ 
            type: UPDATE_PRODUCT_CATEGORY_ERROR, 
            payload: 'Không thể cập nhật danh mục sản phẩm' 
        });
        return { success: false, error: error.message };
    }
};

// Delete a product category
export const deleteProductCategory = (id) => async (dispatch) => {
    dispatch({ type: DELETE_PRODUCT_CATEGORY_START });
    try {
        await api.delete(`/categories/${id}`);
        dispatch({ 
            type: DELETE_PRODUCT_CATEGORY_SUCCESS, 
            payload: id 
        });
        return { success: true };
    } catch (error) {
        console.error('Error deleting product category:', error);
        dispatch({ 
            type: DELETE_PRODUCT_CATEGORY_ERROR, 
            payload: 'Không thể xóa danh mục sản phẩm' 
        });
        return { success: false, error: error.message };
    }
};

// Update categories status (bulk operation)
export const updateProductCategoriesStatus = (categoryIds, isActive) => async (dispatch) => {
    dispatch({ type: UPDATE_PRODUCT_CATEGORY_START });
    try {
        const response = await api.put('/categories/status/batch', {
            categoryIds,
            isActive
        });
        
        // Refresh categories list after bulk update
        dispatch(fetchProductCategories());
        return { success: true, data: response.data };
    } catch (error) {
        console.error('Error updating product categories status:', error);
        dispatch({ 
            type: UPDATE_PRODUCT_CATEGORY_ERROR, 
            payload: 'Không thể cập nhật trạng thái danh mục sản phẩm' 
        });
        return { success: false, error: error.message };
    }
};

// Fetch available codes for filter dropdown
export const fetchAvailableCodes = () => async (dispatch) => {
    try {
        const response = await api.get('/categories/codes');
        return { success: true, data: response.data?.codes || [] };
    } catch (error) {
        console.error('Error fetching available codes:', error);
        return { success: false, error: error.message };
    }
};

// Auto-suggest search
export const searchCategoriesSuggestions = (searchTerm) => async (dispatch) => {
    try {
        if (!searchTerm || searchTerm.trim().length < 2) {
            return { success: true, data: [] };
        }
        
        const response = await api.get(`/categories/search?q=${encodeURIComponent(searchTerm)}&limit=5`);
        return { success: true, data: response.data?.suggestions || [] };
    } catch (error) {
        console.error('Error fetching search suggestions:', error);
        return { success: false, error: error.message };
    }
};

// Apply filters and fetch data from backend
export const applyFilters = (filters) => async (dispatch) => {
    // Update filters in state
    dispatch({ type: SET_CATEGORIES_FILTERS, payload: filters });
    
    // Fetch data with new filters
    return dispatch(fetchProductCategories(filters));
};

// Clear all filters
export const clearFilters = () => async (dispatch) => {
    dispatch({ type: CLEAR_CATEGORIES_FILTERS });
    
    // Fetch data without filters
    return dispatch(fetchProductCategories());
};

// Search categories by text
export const searchCategories = (searchText) => async (dispatch, getState) => {
    const currentFilters = getState().categoryManagement?.productCategories?.filters || {};
    const newFilters = { ...currentFilters, searchText, page: 1 };
    
    return dispatch(applyFilters(newFilters));
};

// Filter by status
export const filterByStatus = (statusFilter) => async (dispatch, getState) => {
    const currentFilters = getState().categoryManagement?.productCategories?.filters || {};
    const newFilters = { ...currentFilters, statusFilter, page: 1 };
    
    return dispatch(applyFilters(newFilters));
};

// Filter by code
export const filterByCode = (codeFilter) => async (dispatch, getState) => {
    const currentFilters = getState().categoryManagement?.productCategories?.filters || {};
    const newFilters = { ...currentFilters, codeFilter, page: 1 };
    
    return dispatch(applyFilters(newFilters));
};

export const filterByProductLine = (productLineFilter) => async (dispatch, getState) => {
    const currentFilters = getState().categoryManagement?.productCategories?.filters || {};
    const newFilters = { ...currentFilters, productLineFilter, page: 1 };

    return dispatch(applyFilters(newFilters));
};

// Change pagination
export const changePagination = (page, pageSize) => async (dispatch, getState) => {
    const currentFilters = getState().categoryManagement?.productCategories?.filters || {};
    const newFilters = { ...currentFilters, page, pageSize };
    
    // Update filters in state first
    dispatch({ type: SET_CATEGORIES_FILTERS, payload: newFilters });
    
    // Then fetch data with new filters
    return dispatch(fetchProductCategories(newFilters));
};
